import {
    UrlsTypes
} from 'actions/types';
import axios from 'axios';

export function fetchExit(route) {
    return (dispatch, getState) => {
        const headers = getState().config.get('headers');
        const host = getState().config.get('host');
        const method = route.get('method');
        const href = route.get('href');
        const url = `${host}${href}`;

        dispatch({
            type: UrlsTypes.FETCH_EXIT,
            payload: {
                headers,
                url,
                method
            }
        })

        return axios({
            headers: headers.toJSON(),
            method: method,
            url: url
        })
        .then(response => {
            return response.data
        })
        .catch(error => {
            let newError = {}
            if (!error.response) {
                newError = {
                    response: {
                        data: {
                            code: error.code,
                            message: error.message
                        }
                    }
                }
            }

            dispatch({
                type: UrlsTypes.ERROR_FETCH_EXIT,
                payload: error.response ? error : newError
            })
            throw error
        })
    }
}

export function fetchUrls() {
    return (dispatch, getState) => {
        const headers = getState().config.get('headers');
        const host = getState().config.get('host');
        const route = getState().config.get('route');
        const href = route.get('href');
        const method = route.get('method');
        const url = `${host}${href}`;

        dispatch({
            type: UrlsTypes.FETCH_URLS,
            payload: {
                headers,
                url,
                method
            }
        })

        return axios({
            headers: headers,
            method: method,
            url: url
        })
        .then(response => {
            return dispatch(setUrls(response))
        })
        .catch(error => {
            let newError = {}
            if (!error.response) {
                newError = {
                    response: {
                        data: {
                            code: error.code,
                            message: error.message
                        }
                    }
                }
            }

            dispatch({
                type: UrlsTypes.ERROR_FETCH_URLS,
                payload: error.response ? error : newError
            })
            throw error
        })
    }
}

export function setUrls(payload) {
    return {
        type: UrlsTypes.SET_URLS,
        payload: payload.data
    }
}